import { useTheme } from '../contexts/ThemeContext';
import './Header.css';

interface HeaderProps {
    query: string;
    onQueryChange: (value: string) => void;
}

const Header = ({ query, onQueryChange }: HeaderProps) => {
    const { theme, toggleTheme } = useTheme();

    return (
        <header className="header">
            <div className="header-inner">
                <a className="brand" href="/" aria-label="尛尛居落工具箱">
                    <span className="brand-mark">尛</span>
                    <span className="brand-text">
                        <span className="brand-title">尛尛居落</span>
                        <span className="brand-subtitle">在线工具箱</span>
                    </span>
                </a>

                <div className="header-search">
                    <svg
                        className="search-icon"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                    >
                        <circle cx="11" cy="11" r="7" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                    <input
                        type="text"
                        className="search-input"
                        placeholder="搜索工具…"
                        value={query}
                        onChange={(e) => onQueryChange(e.target.value)}
                        aria-label="搜索工具"
                    />
                    {query && (
                        <button
                            className="search-clear"
                            onClick={() => onQueryChange('')}
                            aria-label="清空搜索"
                        >
                            ✕
                        </button>
                    )}
                </div>

                <button
                    className="theme-toggle"
                    onClick={toggleTheme}
                    aria-label="切换主题"
                    title={theme === 'light' ? '切换到深色模式' : '切换到浅色模式'}
                >
                    {theme === 'light' ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                        </svg>
                    ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <circle cx="12" cy="12" r="4" />
                            <line x1="12" y1="2" x2="12" y2="4" />
                            <line x1="12" y1="20" x2="12" y2="22" />
                            <line x1="4.93" y1="4.93" x2="6.34" y2="6.34" />
                            <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
                            <line x1="2" y1="12" x2="4" y2="12" />
                            <line x1="20" y1="12" x2="22" y2="12" />
                            <line x1="4.93" y1="19.07" x2="6.34" y2="17.66" />
                            <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
                        </svg>
                    )}
                </button>
            </div>
        </header>
    );
};

export default Header;
